module.exports = __webpack_public_path__ + "static/media/voltgroom-3.a555a69b.jpg";